@if (datePicker) {
  <div class="filter-container popCalender" #datePickerWrapper>
    <h2 class="filter-calender-title">
      {{ minDate ? 'Plan termination settings.' : 'Please select date.' }}
    </h2>
    @if (!enterDateManually) {
      <ngb-datepicker
        class="filter-calendar"
        [startDate]="model"
        navigation="arrows"
        (dateSelect)="onDateSelection($event)"
        [displayMonths]="2"
        [firstDayOfWeek]="0"
        [minDate]="minDate"
        [maxDate]="maxDate"
        [(ngModel)]="model"
        [markDisabled]="isDisabled"
      >
      </ngb-datepicker>
    }
    <div class="manual-entry-wrapper">
      @if (!enterDateManually) {
        <button type="button" class="no-border-btn btn-link font-regular font-light nounderline cursor-pointer" (click)="enterDateManually = true" data-cy="enter-date-btn">Enter date manually</button>
      }
      @if (enterDateManually) {
        <mat-form-field appearance="fill">
          <mat-label>Enter date in mm/dd/yyyy format</mat-label>
          <input matInput class="input-date" [(ngModel)]="manuallyEnteredDate" aria-describedby="manually-entered-date-error" data-cy="manual-date-input" />
        </mat-form-field>
      }
      @if (manuallyEnteredDateError !== '') {
        <div class="manually-entered-date-error" id="manually-entered-date-error">{{ manuallyEnteredDateError }}<br /><br /></div>
      }
      @if (enterDateManually) {
        <button type="button" class="mat-primary mat-flat-button save-btn" (click)="saveManuallyEnteredDate()" data-cy="save-btn">Save</button>
      }
      @if (enterDateManually) {
        <button type="button" class="no-border-btn btn-link font-regular font-light nounderline cursor-pointer" (click)="backToCalendarView()">Back to Calendar View</button>
      }
    </div>
  </div>
}
